import { render, staticRenderFns } from "./BaseFooter.vue?vue&type=template&id=5e355c33&scoped=true&"
import script from "./BaseFooter.vue?vue&type=script&lang=ts&"
export * from "./BaseFooter.vue?vue&type=script&lang=ts&"
import style0 from "./BaseFooter.vue?vue&type=style&index=0&id=5e355c33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e355c33",
  null
  
)

export default component.exports
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QToolbar,QToolbarTitle,QIcon,QBtn});
